declare const __ZION_BUILD__: string

export const ZION_BUILD = typeof __ZION_BUILD__ !== 'undefined' ? __ZION_BUILD__ : 'dev'

export function formatBuildLabel(): string {
  if (ZION_BUILD === 'dev') return 'dev'
  const y = ZION_BUILD.slice(0, 4)
  const mo = ZION_BUILD.slice(4, 6)
  const d = ZION_BUILD.slice(6, 8)
  const h = ZION_BUILD.slice(8, 10)
  const mi = ZION_BUILD.slice(10, 12)
  return `${y}-${mo}-${d} ${h}:${mi} UTC`
}
